import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ArrowBack from 'assets/arrow_back.svg?react';
import { Button } from '@agconnections/grow-ui';
import { Context } from 'components/Store';
import { IS_FARM_EDITED } from 'reducers/reducer';
import { Col, Row } from 'syngenta-digital-cropwise-react-ui-kit';
import createAction from 'helpers/createAction';
import useExportPDFMapsActions from 'screens/Property/hooks/useExportPDFMapsActions';

const Title = ({ title, showGoBack, className }) => {
  const [
    { isMassAssignerActive, isExportPDFMapsActive, exportPDFMapsStep },
    dispatch
  ] = useContext(Context);

  const {
    clearExportForm,
    closeExportFlow,
    goToExportStep
  } = useExportPDFMapsActions(dispatch);

  const backHome = () => {
    createAction(dispatch, IS_FARM_EDITED, true);
    if (isExportPDFMapsActive) {
      if (exportPDFMapsStep === 1) {
        goToExportStep(0);
      } else {
        clearExportForm();
        closeExportFlow();
      }
    }
  };

  return isMassAssignerActive ? null : (
    <Row className="flex flex-wrap justify-start ml-1">
      {showGoBack && (
        <Button
          ariaLabel="back"
          style={{ marginRight: '0.5rem' }}
          type="text"
          icon={<ArrowBack />}
          onClick={backHome}
        />
      )}
      <Col
        className={`${
          showGoBack ? 'text-xl' : 'text-3xl'
        } font-semibold ${className}`}
      >
        {title}
      </Col>
    </Row>
  );
};

Title.propTypes = {
  title: PropTypes.string.isRequired,
  showGoBack: PropTypes.bool.isRequired,
  className: PropTypes.string
};

Title.defaultProps = {
  className: ''
};

export default Title;
